import { useEffect, useState } from "react";
import { WALLET_FIND_ALL_TERMINALS } from "../../../api-calls/WalletApi";
import Map, { MarkedLocation } from "../../molecules/Map/Map";
import { LatLngLiteral } from "leaflet";
import MarkerPopupContent from "./MarkerPopupContent";
import { MapPlaceholder } from "src/pages/coinWithdraw/styles";

interface Props {
  zoom?: number;
  onClickMarker: (id: string, location: LatLngLiteral) => void;
  height?: number;
}

function TerminalsMap(props: Props) {
  const { zoom, onClickMarker } = props;
  const [locations, setLocations] = useState<MarkedLocation[]>([]);

  useEffect(() => {
    WALLET_FIND_ALL_TERMINALS().then((payload) => {
      const list: MarkedLocation[] = payload.data.data.map((l) => {
        return {
          id: l.terminalNo,
          lat: Number(l.location_lat),
          lng: Number(l.location_long),
          text: <MarkerPopupContent terminal={l} />,
        };
      });
      setLocations(list);
    });
  }, []);

  console.log(locations);

  return locations.length ? (
    <Map
      defaultLocation={{ lat: locations[0].lat, lng: locations[0].lng }}
      markedLocations={locations}
      onClickMarker={onClickMarker}
      zoom={zoom}
      height={props.height}
    />
  ) : (
    <MapPlaceholder height={props.height} />
  );
}

export default TerminalsMap;
